/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

/* ------------------------------------------------------------------------
speakerNum works as follows:

- In this component, in what gets sent to the backend, and in what is stored in the DB:
0 == None selected
1 == Speaker 1
2 == Speaker 2

- In the EvaluateRecording and metrics components, speakerNum is:
0 == Speaker 1
1 == Speaker 2

Maybe this isn't great...
----------------------------------------------------------------------------- */

<template>
  <span
    v-if="recording.speakerNum"
  >
    <span v-if="recording.speakerNum == speakerNum">
      {{ recording.userFirstName }}
      <span class="identificationSpan">
        [
        <a
          class="identifySpeaker"
          @click.prevent="identifySpeaker(0)"
        >
          This is not {{ recording.userFirstName }}
        </a>
        ]
      </span>
    </span>
    <span v-else>
      SPEAKER {{ speakerLabel }}
    </span>
  </span>
  <span v-else>
    SPEAKER {{ speakerLabel }}
    <span class="identificationSpan">
      [
      <a
        class="identifySpeaker"
        @click.prevent="identifySpeaker(speakerNum)"
      >
        This is {{ recording.userFirstName }}
      </a>
      ]
    </span>
  </span>
</template>

<style lang="less" scoped>
  a.identifySpeaker {
    cursor: pointer;
  }
  .identificationSpan {
    font-size: 10pt;
  }
</style>

<script>
export default {
  props: ['speakerNum', 'recording'],
  computed: {
    speakerLabel() {
      const sn = window.parseInt(this.speakerNum, 10);
      switch (sn) {
      case 1:
        return 'ONE';
        break;
      case 2:
        return 'TWO';
        break;
      case 3:
        return 'THREE';
        break;
      case 4:
        return 'FOUR';
        break;
      default:
        return 'FIVE';
        break;
      }
    }
  },
  methods: {
    identifySpeaker(speakerNum) {
      return this.$emit('speakerIdentified', speakerNum);
    }
  }
};
</script>
